// routes
import { paths } from 'src/routes/paths';

// API
// ----------------------------------------------------------------------
// export const HOST_API = 'https://api.mhalt.com';
// export const HOST_API = 'https://api.revdsm.com';
// export const HOST_API = 'https://staging-api.revdsm.com';
// export const HOST_API = 'http://192.168.100.158:4009'; //5.0 II
export const HOST_API = process.env.REACT_APP_API_URL;
export const WEATHER_API_KEY = process.env.REACT_APP_WEATHER_API_KEY;
export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
export const WEATHER_API = 'https://api.weatherapi.com/v1';

// export const HOST_API = 'http://192.168.100.238:4009';
// export const HOST_API = 'http://200.10.20.25:4009';
// export const HOST_API = 'http://192.168.100.199:4009/' ;
export const ASSETS_API = 'https://api-dev-minimal-v510.vercel.app';

export const FIREBASE_API = {
  // apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  // authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  // projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  // storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  // messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  // appId: process.env.REACT_APP_FIREBASE_APPID,
  // measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const AMPLIFY_API = {
  userPoolId: process.env.REACT_APP_AWS_AMPLIFY_USER_POOL_ID,
  userPoolWebClientId: process.env.REACT_APP_AWS_AMPLIFY_USER_POOL_WEB_CLIENT_ID,
  region: process.env.REACT_APP_AWS_AMPLIFY_REGION,
};

export const AUTH0_API = {
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  callbackUrl: process.env.REACT_APP_AUTH0_CALLBACK_URL,
};

export const MAPBOX_API = process.env.REACT_APP_MAPBOX_API;

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = paths.dashboard.root; // as '/dashboard'

// MAIN APP URL for authentication redirects
export const MAIN_APP_URL = process.env.REACT_APP_MAIN_APP_URL;
